export const IconWarning = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M70 35C70 54.33 54.33 70 35 70C15.67 70 0 54.33 0 35C0 15.67 15.67 0 35 0C54.33 0 70 15.67 70 35Z"
        fill="#1890FF"
      />
      <path
        d="M33.9619 41.206C33.9619 40.3573 34.6507 39.6562 35.4994 39.6562C36.3481 39.6562 37.0369 40.3348 37.0369 41.1835V41.206C37.0369 42.0547 36.3481 42.7435 35.4994 42.7435C34.6507 42.7435 33.9619 42.0547 33.9619 41.206Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.5694 16.983L55.4821 43.0829C55.5149 43.1403 55.544 43.1998 55.5691 43.2609C55.8181 43.8665 55.9561 44.5053 55.9918 45.1433L55.9922 45.1504C56.1568 48.3506 53.696 51.0746 50.4986 51.2418C50.4719 51.2432 50.4451 51.2439 50.4183 51.2439H20.7308C20.706 51.2439 20.6814 51.2434 20.6569 51.2422C20.6036 51.2448 20.5496 51.2446 20.4951 51.2415C19.8554 51.2057 19.2228 51.0675 18.621 50.8251L18.6154 50.8228C15.6512 49.6154 14.2227 46.2352 15.4277 43.2672C15.4535 43.2039 15.4834 43.1423 15.5173 43.0829L30.4299 16.9834C30.9572 16.0338 31.7423 15.2496 32.6958 14.7254C35.4956 13.177 39.0166 14.1891 40.5694 16.983ZM20.6563 48.1708C20.681 48.1696 20.7058 48.169 20.7308 48.169H50.3737C51.8604 48.0721 52.9963 46.8007 52.9215 45.3117C52.9054 45.0308 52.8494 44.7606 52.7571 44.5118L37.8842 18.4817C37.1554 17.1643 35.4983 16.6878 34.1817 17.4175L34.1771 17.4201C33.7319 17.6648 33.363 18.033 33.1155 18.481L33.1049 18.5001L18.2438 44.5094C17.7386 45.8816 18.4088 47.4166 19.7725 47.9739C20.0521 48.0862 20.3496 48.1525 20.6563 48.1708Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.4784 27.4219C36.3275 27.4219 37.0159 28.1102 37.0159 28.9593V35.3142C37.0159 36.1633 36.3275 36.8517 35.4784 36.8517C34.6293 36.8517 33.9409 36.1633 33.9409 35.3142V28.9593C33.9409 28.1102 34.6293 27.4219 35.4784 27.4219Z"
        fill="white"
      />
    </svg>
  );
};
